import {BillingLine} from '../../../billing-line/billing-line.model';
import {DiscoPricingItemMapper} from './disco-pricing-item.mapper';
import { ProductV2 } from '../../../productv2/productv2.model';
import { DiscoDasriRenewalPricingItemInitializer } from 'src/app/components/article-selection-form/disco/dasri/disco.dasri.renewal-pricing-item-initializer';


export class DiscoDasriPricingItemMapper extends DiscoPricingItemMapper {

    mapPricingItemFromProduct(product: ProductV2, cc: BillingLine, referential: any, idx: string) {
        let pricingItem = this.mapProductToPricingItemWithCustomerContract(product, cc, idx);
        const frDiscoPricingItemInitializer = new DiscoDasriRenewalPricingItemInitializer(new DiscoPricingItemMapper(true));
        const prefilledInputs = frDiscoPricingItemInitializer.getPrefilledInputs(product.priceList?.productPricings, referential, cc);
        const userInputs = frDiscoPricingItemInitializer.initUserInputs(cc, prefilledInputs, pricingItem);
        return pricingItem.copyWith({ userInputs, prefilledInputs });
    }

}
